import { Navigate, useParams } from 'react-router';
import { gpsIntegrationPath } from '../features/gps/gps.paths';

/** `/integrations/installed/:id` from before GPS integrations had their own page (CLAUDE.md → Tabs are routes: moved URLs keep a redirect). */
export function MovedGpsIntegrationRedirect() {
  const { id = '' } = useParams();
  return <Navigate to={gpsIntegrationPath(id)} replace />;
}
